import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigatorService } from '@m4u-angular/core/framework/navigator.service';
import { ResourcesService } from '@m4u-angular/core/framework/resources.service';
import { SessionService, SessionStates } from '@m4u-angular/core/framework/session.service';
import { EnumMessageBoxTypes } from '@m4u-angular/core/framework/sysenums.enum';
import { SystemOptionsService } from '@m4u-angular/core/framework/system-options.service';
import { EnumSystemOptions } from '@m4u-angular/core/framework/sysenums.enum';
import { MessageBoxDialogComponent } from '@m4u-angular/ui/dialogs/messagebox-dialog/messageboxdialog.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { SystemEndpoint } from '@core/endpoints/system.endpoint';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';

@Component({
    selector: 'm4u-session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.scss']
})
export class SessionExpiredComponent implements OnInit, OnDestroy {
    @ViewChild(MessageBoxDialogComponent) messageDialog: MessageBoxDialogComponent;
    private sessionState$Subscription: Subscription;
    // @ts-ignore
    private isMessageDialogInDOM: boolean = true;

    constructor(private sessionService: SessionService,
        private resourcesService: ResourcesService,
        private navigatorService: NavigatorService,
        private systemOptionsService: SystemOptionsService,
        private systemEndpoint: SystemEndpoint,
        private sidebarService: SidebarService) {
    }

    ngOnInit() {
        this.sessionState$Subscription = this.sessionService.sessionStateChanged$
            .subscribe(state => {
                if (state === SessionStates.AlmostExpired || state === SessionStates.Expired) {
                    this.ShowExpiredDialog(state);
                }
            });
    }

    ngOnDestroy() {
        this.sessionState$Subscription && this.sessionState$Subscription.unsubscribe();
    }

    ShowExpiredDialog(state: SessionStates) {
        const showDialog = (title, prompt, onClose?: (e: any) => void) => {
            this.messageDialog.Type = EnumMessageBoxTypes.Custom;
            if (state === SessionStates.AlmostExpired) {
                this.messageDialog.Buttons = [
                    { Text: this.resourcesService.RC('btnLogOff'), ButtonID: 0 },
                    { Text: this.resourcesService.RC('btnStayConnected'), ButtonID: 1 }
                ];
            }
            else if (state === SessionStates.Expired) {
                this.messageDialog.Buttons = [
                    { Text: this.resourcesService.RC('btnGoToHomePage'), ButtonID: 0 },
                ];
            }
            this.messageDialog.Title = title;
            this.messageDialog.Prompt = prompt;
            this.messageDialog.ShowDialogShort(onClose);
        };

        if (state === SessionStates.AlmostExpired &&
            this.systemOptionsService.getSystemOptionAsBoolean(EnumSystemOptions.ShowAlmostExpiredTimeoutAlert)) {
            showDialog(
                this.resourcesService.RC('lblSessionAlmostExpiredTitle'),
                this.resourcesService.RC('lblSessionAlmostExpiredPrompt'), e => {
                    if (e === 0) {
                        this.sidebarService.ClearSidebars();
                        this.navigatorService.Navigate(['/system/logout']);
                    } else if (e === 1) {
                        this.systemEndpoint.KeepAlive().subscribe(_ => { });
                    }
                });
        }

        if (state === SessionStates.Expired &&
            this.systemOptionsService.getSystemOptionAsBoolean(EnumSystemOptions.ShowExpiredTimeoutAlert)) {
            showDialog(this.resourcesService.RC('lblSessionExpiredTitle'), this.resourcesService.RC('lblSessionExpiredPrompt'), () => {
                // Switch off/on a message-dialog to restart the native angular lifecycle. 
                // Hack! Related to an issue when the message-box doesn't appear after the first showing.
                // Remove after an issue will be fixed.
                this.isMessageDialogInDOM = false;

                setTimeout(() => {
                    this.sidebarService.ClearSidebars();
                    this.navigatorService.Navigate(['/system/login']);
                    this.isMessageDialogInDOM = true;
                }, 200);
            });
        }
    }

}
